import { render, staticRenderFns } from "./DIS_scondHero.vue?vue&type=template&id=0bce9764&"
import script from "./DIS_scondHero.vue?vue&type=script&lang=js&"
export * from "./DIS_scondHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports